module.exports={
    logout  : "退出帳號",
    my      :'我的',
    scqx    :'删除許可權',
    qxgl    :'許可權管理',
    qdzxzhm :'確定註銷帳號嗎？',
    qtxkh   :'請填寫卡號',
    qd      :'確定',
    qx      :'取消',
    gb      :'關閉',
    kh      :'卡號',
    kmewm   :'開門二維碼',
    dl      :'登录',
    name    :'用戶名',
    qtxname :'請填寫用戶名',
    pwas    :'密碼',
    qtxpwas :'請填寫密碼',
    tj      :'提交',
    zczh    :'註冊帳號',
    zc      :'注册',
    sjhm    :'手機號碼',
    qtxsjhm :'請填寫手機號碼',
    yzm     :'簡訊驗證碼',
    qtxyzm  :'請填寫驗證碼',
    yyzhqqdl:'已有帳號，前去登入',
    hqyzm   :'獲取簡訊驗證碼',
    zccg    :'注册成功',
    zcsb    :'注册失敗',
    fscg    :'發送成功',
    fssb    :'發送失敗',
    yhycz   :'用戶已存在',


    xgmm    : "修改密碼",
    zhmm    :'找回密碼',
    qrmm    :'確認密碼',
    zhyxmm  :"找回密碼郵箱",
    yxyzm   :'郵箱驗證碼',
    hqyxyzm :'獲取郵箱驗證碼',
    zzmmyx  :'重置密碼郵箱',
    lcmmbyc :'倆次密碼不一致',
    xgcg    :'修改成功',
    xgsb    :'修改失敗',
    qtxyxyx  :'請填寫有效郵箱',
    lsmhhq  :'60秒後重新獲取',
    hqyyyzmcg:'獲取郵箱驗證碼成功',
    zhmmbd  :'帳號密碼不正確'
}